import React, { useEffect, useRef } from 'react';

const VideoJS = (props) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const { options, onReady } = props;
  const currentOptions = useRef(null);

  useEffect(() => {
    // Criação do player de vídeo
    const videoElement = document.createElement("video");
    videoElement.classList.add('video-js');
    videoElement.classList.add('vjs-big-play-centered');
    videoRef.current.appendChild(videoElement);

    playerRef.current = videojs(videoElement, options, () => {
      console.log('Player está pronto');
      onReady && onReady(playerRef.current);
    });

    // Limpeza do player de vídeo
    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, []); // Dependência vazia para criar o player apenas uma vez

  useEffect(() => {
    // Atualização das opções do player de vídeo
    if (playerRef.current && JSON.stringify(currentOptions.current) !== JSON.stringify(options)) {
      console.log("Mudou options");
      const player = playerRef.current;
      player.autoplay(options.autoplay);
      player.src(options.sources);
      currentOptions.current = options;
    }
  }, [options]); // Atualizações apenas quando as opções mudarem

  return (
    <div data-vjs-player>
      <div ref={videoRef} />
    </div>
  );
};

export default VideoJS;